import { z } from 'zod';
import { PortalUserSchema } from '../../base/user.js';
export const UpdatePortalUserRequestBodySchema = PortalUserSchema.pick({
    auth0Id: true,
    email: true,
    externalUserId: true,
    phoneNumber: true,
    name: true,
}).merge(z.object({
    entityPermissions: PortalUserSchema.shape.entityPermissions.optional(),
    portalUserId: PortalUserSchema.shape.portalUserId.optional(),
    requestActor: z.string(),
}));
export const UpdatePortalUserRequestSchema = UpdatePortalUserRequestBodySchema;
export const UpdatePortalUserResponseSchema = z.object({ user: PortalUserSchema.or(z.null()) });
export const UpdatePortalUserApiSchema = {
    body: UpdatePortalUserRequestBodySchema,
    response: UpdatePortalUserResponseSchema,
};
